import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';
import { AuthProvider, useAuth } from '../../common/auth';
import Header from '../Header';
import Login from '../Login';
import PrivateRoute from '../PrivateRoute';
import SignUp from '../SignUp';
import Status from '../Status';
import { AppLoadingProvider } from '../AppLoadingProvider';
import ApiKeyDetails from '../ApiKeyDetails';
import AddApiKey from '../AddApiKey';
import ConfirmEmailSuccess from '../ConfirmEmailSuccess';
import ConfirmEmailFailure from '../ConfirmEmailFailure';
import InitiatePasswordReset from '../InitiatePasswordReset';
import PasswordReset from '../PasswordReset';

function App() {
  return <div className="app">
    <AppLoadingProvider>
      <Router>
        <AuthProvider>
          <Header />
          <Main />
        </AuthProvider>
      </Router>
    </AppLoadingProvider>
  </div>;
}

function Main() {
  const { user } = useAuth();

  return <main>
    <Switch>
      <Route path="/login">
        <Login />
      </Route>
      <Route path="/signup">
        <SignUp />
      </Route>
      <PrivateRoute path="/status/new">
        <AddApiKey />
      </PrivateRoute>
      <PrivateRoute path="/status/:id">
        <ApiKeyDetails />
      </PrivateRoute>
      <PrivateRoute path="/status">
        <Status />
      </PrivateRoute>
      <Route path="/email-confirmation-success">
        <ConfirmEmailSuccess />
      </Route>
      <Route path="/email-confirmation-failure">
        <ConfirmEmailFailure />
      </Route>
      <Route path="/initiate-password-reset">
        <InitiatePasswordReset />
      </Route>
      <Route path="/password-reset/:token">
        <PasswordReset />
      </Route>
      <Route path="/">
        {
          user ? <Status /> : <SignUp />
        }
      </Route>
    </Switch>
  </main>;
}

export default App;